// @flow

import * as React from 'react';
import styles from './Placeholder.css';

type Props = {
  editable: boolean,
  onClickAddEstimateCaveat: () => void,
  onClickSelectCaveatFromList: () => void,
}

class Component extends React.PureComponent<Props> {

  render () {

    const {
      editable,
      onClickAddEstimateCaveat,
      onClickSelectCaveatFromList
    } = this.props;

    return (

      <div
        className={styles.wrapper}
      >

        <div className={styles.message}>

          {'There are no caveats on this estimate. '}

          {editable && (
            <span>
              <span
                className={styles.addLink}
                onClick={onClickSelectCaveatFromList}
                role="presentation"
              >
                {'Add From List'}
              </span>
              {' or '}
              <span
                className={styles.addLink}
                onClick={onClickAddEstimateCaveat}
                role="presentation"
              >
                {'Add Blank Caveat'}
              </span>
              {' to get started.'}
            </span>
          )}

        </div>

      </div>

    )
  }
}

export default Component;